import { BookOpenIcon, CalendarDaysIcon, ClipboardCheckIcon, HeartPulseIcon, ScissorsIcon, StethoscopeIcon } from 'lucide-react';

export const modules = [
  [
    '01',
    'Fundamentos de la Instrumentación Quirúrgica',
    'Historia de la instrumentación, evolución de la profesión en Argentina, legislación vigente (Ley 26.058, INET, AAIQ), perfil profesional y competencias, equipo quirúrgico, organización del centro quirúrgico, bioseguridad, asepsia, esterilización, lavado quirúrgico, vestimenta estéril y terminología médica completa.',
    'Tus alumnos entienden por qué la instrumentación quirúrgica argentina tiene estándares propios, qué dice el INET sobre el perfil del egresado y por qué cada protocolo del quirófano existe para salvar vidas.',
    BookOpenIcon,
    'ASEPSIA · ESTERILIZACIÓN · LAVADO QUIRÚRGICO · BIOSEGURIDAD · AAIQ · INET · LEY 26.058',
  ],
  [
    '02',
    'Instrumental Quirúrgico Completo',
    'Clasificación general del instrumental, bisturí y hojas, instrumental de corte, disección, prensión, hemostasia, separación y síntesis. Catálogo maestro de pinzas, tijeras, portaagujas y separadores. Suturas y agujas, cuidados, limpieza, mantenimiento y organización por mesas, con fichas técnicas identificatorias.',
    'Identifican cada instrumento por nombre, característica y función, conocen la regla Mayo vs Metzenbaum y pueden armar cualquier mesa quirúrgica sin guía.',
    ScissorsIcon,
    'BISTURÍ · MAYO/METZENBAUM · KOCHER · KELLY · CRILE · ALLIS · BABCOCK · BALFOUR · VICRYL · PROLENE · PDS',
  ],
  [
    '03',
    'Instrumentación por Especialidades Quirúrgicas',
    'Las 16 especialidades más relevantes: general, digestiva, traumatología, ortopedia, neurocirugía, ginecología, obstetricia, urología, infantil, plástica, maxilofacial, ORL, cardiovascular, torácica, vascular periférica y oftalmología, con instrumental específico, posicionamiento y puntos críticos.',
    'Entienden qué instrumento necesita cada especialidad, por qué el Finochietto es para el tórax y el Balfour para el abdomen, y cómo funciona la trazabilidad del implante en ortopedia.',
    StethoscopeIcon,
    'COLECISTECTOMÍA · CESÁREA · ATC · CRANEOTOMÍA · CABG · HISTERECTOMÍA · TRAZABILIDAD · LAPAROSCOPÍA',
  ],
  [
    '04',
    'Organización del Quirófano y Procedimientos',
    'Diseño del quirófano, zonas y flujos de circulación, Mesa de Mayo y Mesa de Instrumental, conteo de instrumental, gasas, compresas y agujas, protocolo de discrepancia, Checklist OMS adaptado a Argentina, seguridad del paciente, urgencias intraoperatorias y trabajo interdisciplinario.',
    'Aplican el Checklist OMS con sus 3 momentos, realizan el conteo quirúrgico documentado y saben qué hacer ante una hemorragia masiva o una conversión de urgencia.',
    ClipboardCheckIcon,
    'CHECKLIST OMS · CONTEO QUIRÚRGICO · SIGN IN · TIME OUT · SIGN OUT · CER · EVENTO CENTINELA',
  ],
  [
    '05',
    'Prácticas Profesionales y Simulación Clínica',
    'Fundamentos de la simulación clínica, laboratorio de bajo costo para institutos argentinos, 30 casos prácticos resueltos por especialidad, armado completo del quirófano, 20 situaciones críticas, talleres, ABP, evaluaciones prácticas y prácticas integradoras finales.',
    'Simulan cirugías reales, resuelven urgencias intraoperatorias y llegan a la práctica hospitalaria con la experiencia de 150 cirugías simuladas antes de ver un paciente real.',
    HeartPulseIcon,
    'SIMULACIÓN CLÍNICA · ABP · DEBRIEFING · CESÁREA DE URGENCIA · CONVERSIÓN · MODELO 3D · KOLB',
  ],
  [
    '06',
    'Planificación Docente 2026',
    'Marco normativo de la ETP, perfil del egresado según el INET, Taxonomía de Bloom aplicada a IQ, planificación anual lista para adaptar, planificaciones trimestrales semana a semana, secuencias didácticas, rúbricas, listas de cotejo, proyectos interdisciplinarios y exámenes listos para usar.',
    'Tenés el ciclo lectivo 2026 organizado desde el día uno, articulado con el Marco de Referencia del INET y los diseños curriculares provinciales.',
    CalendarDaysIcon,
    'ABP · BLOOM · PLANIFICACIÓN ANUAL · SECUENCIAS · RÚBRICAS · INET · ETP · ARGENTINA 2026',
  ],
] as const;
